module.exports = __webpack_public_path__ + "static/media/2-4.1f8b63d8.svg";